import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'
import { MDBCardTitle, MDBCardText, MDBBtn, MDBTable, MDBTableHead, MDBTableBody, MDBCard, MDBCardBody } from 'mdb-react-ui-kit';
import '../../../css/index.css';



function ListarADM() {

  const api = require('../../../apis/adm')
  const [usuarios, setUsuarios] = useState([]);
  const utils = require('../../../utils/index');
  const user = utils.getUser();

  const navigate = useNavigate();

  const getUsers = async () => {
    try {
      // Simulando uma chamada assíncrona (substitua por sua lógica real)
      const response = await api.listarADMApi();
      const data = await response;

      // Verificando se os dados são uma array antes de definir o estado
      if (Array.isArray(data)) {
        setUsuarios(data);
      } else {
        console.error('Os dados obtidos não são uma array:', data);
      }
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };

  // Chame a função de busca quando o componente for montado
  useEffect(() => {
    getUsers( );
  }, []); 
  return (
    <div className="w-100 d-flex align-items-center justify-content-center" style={{height:'100vh'}}>
      <MDBCard className='bg-dark w-75' style={{minWidth:'350px'}}>
        <MDBCardBody className='bg-dark w-100 text-white'>
        <MDBCardTitle className='text-white'>Bem vindo, {user.nomeusuario}</MDBCardTitle>
          <MDBCardText className='text-white'>
            O que veio fazer?
          </MDBCardText>
          <div style={{maxHeight: '500px', overflow: 'auto'}}>
            <MDBTable align='middle' className='text-white '  >
              <MDBTableHead>
                <tr>
                  <th scope='col'>ID</th>
                  <th scope='col'>Nome</th>
                  <th scope='col'>Login</th>
                  <th scope='col'>Ações</th>
                </tr>
              </MDBTableHead>
              <MDBTableBody >
              {usuarios.map((usuario) => (
                  <tr key={usuario.id}>
                  <td>{usuario.id}</td>
                  <td>{usuario.nomeusuario}</td>
                  <td>{usuario.login}</td>
                  <td>
                    <MDBBtn 
                      color='link' 
                      rounded 
                      size='sm'
                      onClick={() => {
                        navigate(`/editar-adm/${usuario.id}`)
                      }}
                      >
                      Editar
                    </MDBBtn>
                  </td>
                </tr>
              ))}
              </MDBTableBody>
            </MDBTable>
          </div>
          <MDBBtn 
              className='btn-home w-100 mt-4'
              size='sm'
              outline 
              color='white' 
              onClick={() => {
                navigate("/area-adm")
              }}
              >Voltar</MDBBtn>
        </MDBCardBody>
      </MDBCard>
    </div>
  );
}

export default ListarADM;